module.exports = __webpack_public_path__ + "components/flag/static/square/zm-c8e1f72a29ad6dfcb5d6a1ff1338ca53.svg";